import { ScreenSize } from 'ha/modules/UI/constants';
import { TypeValue } from 'ha/types/SearchFilters';

export const STATE_NAME = 'search';

export const ACTION_PREFIX = 'Search';

export const Actions = {
  INITIALIZE: `${ACTION_PREFIX}.INITIALIZE`,
  HIGHLIGHT_ROOM: `${ACTION_PREFIX}.HIGHLIGHT_ROOM`,
  UNHIGHLIGHT_ROOM: `${ACTION_PREFIX}.UNHIGHLIGHT_ROOM`,
  HIGHLIGHT_INFO_WINDOW: `${ACTION_PREFIX}.HIGHLIGHT_INFO_WINDOW`,
  UNHIGHLIGHT_INFO_WINDOW: `${ACTION_PREFIX}.UNHIGHLIGHT_INFO_WINDOW`,
  SHOW_INFO_WINDOW: `${ACTION_PREFIX}.SHOW_INFO_WINDOW`,
  HIDE_INFO_WINDOW: `${ACTION_PREFIX}.HIDE_INFO_WINDOW`,
  UPDATE_MAP: `${ACTION_PREFIX}.UPDATE_MAP`,
  DISABLE_MAP: `${ACTION_PREFIX}.DISABLE_MAP`,
  TOGGLE_MAP_AUTO_SEARCH: `${ACTION_PREFIX}.TOGGLE_MAP_AUTO_SEARCH`,
  UPDATE_SEARCH_PARAMS: `${ACTION_PREFIX}.UPDATE_SEARCH_PARAMS`,
  SET_PREVIOUS_PARAMS: `${ACTION_PREFIX}.SET_PREVIOUS_PARAMS`,
  FILTER_APPLIED: `${ACTION_PREFIX}.FILTER_APPLIED`,
  TOGGLE_FILTER_POPOVER: `${ACTION_PREFIX}.TOGGLE_FILTER_POPOVER`,

  CHANGE_DATE_FILTER: `${ACTION_PREFIX}.CHANGE_DATE_FILTER`,
  CHANGE_PRICE_FILTER: `${ACTION_PREFIX}.CHANGE_PRICE_FILTER`,
  CHANGE_CURRENCY: `${ACTION_PREFIX}.CHANGE_CURRENCY`,
  CHANGE_PAGE: `${ACTION_PREFIX}.CHANGE_PAGE`,
  CHANGE_FILTERS: `${ACTION_PREFIX}.CHANGE_FILTERS`,

  REPLACE_PAGE: `${ACTION_PREFIX}.REPLACE_PAGE`,

  LOAD_START: `${ACTION_PREFIX}.LOAD_START`,
  LOAD_DONE: `${ACTION_PREFIX}.LOAD_DONE`,
  LOAD_ERROR: `${ACTION_PREFIX}.LOAD_ERROR`,
  LOAD_NOT_FOUND: `${ACTION_PREFIX}.LOAD_NOT_FOUND`,

  LOAD_UNIVERSITIES_START: `${ACTION_PREFIX}.LOAD_UNIVERSITIES_START`,
  LOAD_UNIVERSITIES_DONE: `${ACTION_PREFIX}.LOAD_UNIVERSITIES_DONE`,

  LOAD_CITIES_NEARBY_START: `${ACTION_PREFIX}.LOAD_CITIES_NEARBY_START`,
  LOAD_CITIES_NEARBY_DONE: `${ACTION_PREFIX}.LOAD_CITIES_NEARBY_DONE`,

  LOAD_CURRENCY_RATES_START: `${ACTION_PREFIX}.LOAD_CURRENCY_RATES_START`,
  LOAD_CURRENCY_RATES_DONE: `${ACTION_PREFIX}.LOAD_CURRENCY_RATES_DONE`,
  LOAD_CURRENCY_RATES_ERROR: `${ACTION_PREFIX}.LOAD_CURRENCY_RATES_ERROR`,

  UPDATE_SEARCH_START: `${ACTION_PREFIX}.UPDATE_SEARCH_START`,
  UPDATE_SEARCH_DONE: `${ACTION_PREFIX}.UPDATE_SEARCH_DONE`,
  UPDATE_SEARCH_ERROR: `${ACTION_PREFIX}.UPDATE_SEARCH_ERROR`,

  LOAD_PREVIEW_NUMBER_OF_LISTINGS_START: `${ACTION_PREFIX}.LOAD_PREVIEW_NUMBER_OF_LISTINGS_START`,
  LOAD_PREVIEW_NUMBER_OF_LISTINGS_DONE: `${ACTION_PREFIX}.LOAD_PREVIEW_NUMBER_OF_LISTINGS_DONE`,
  LOAD_PREVIEW_NUMBER_OF_LISTINGS_ERROR: `${ACTION_PREFIX}.LOAD_PREVIEW_NUMBER_OF_LISTINGS_ERROR`,
  LOAD_PREVIEW_NUMBER_OF_LISTINGS_CLEAR: `${ACTION_PREFIX}.LOAD_PREVIEW_NUMBER_OF_LISTINGS_CLEAR`,

  TOGGLE_MOBILE_MAP: `${ACTION_PREFIX}.TOGGLE_MOBILE_MAP`,
  TOGGLE_MOBILE_DATE_PICKER: `${ACTION_PREFIX}.TOGGLE_MOBILE_DATE_PICKER`,
  CREATE_SEARCH_ALERT_START: `${ACTION_PREFIX}.CREATE_SEARCH_ALERT_START`,
  CREATE_SEARCH_ALERT_DONE: `${ACTION_PREFIX}.CREATE_SEARCH_ALERT_DONE`,
  CREATE_SEARCH_ALERT_ERROR: `${ACTION_PREFIX}.CREATE_SEARCH_ALERT_ERROR`,

  GET_SEARCH_ALERT_START: `${ACTION_PREFIX}.GET_SEARCH_ALERT_START`,
  GET_SEARCH_ALERT_DONE: `${ACTION_PREFIX}.GET_SEARCH_ALERT_DONE`,

  LOAD_ADVERTISER_START: `${ACTION_PREFIX}.LOAD_ADVERTISER_START`,
  LOAD_ADVERTISER_DONE: `${ACTION_PREFIX}.LOAD_ADVERTISER_DONE`,
  LOAD_ADVERTISER_ERROR: `${ACTION_PREFIX}.LOAD_ADVERTISER_ERROR`,
};

export const enum SuggestionBarActionTypes {
  SHOW_SUGGESTION_BAR = 'Search.SHOW_SUGGESTION_BAR',
  HIDE_SUGGESTION_BAR = 'Search.HIDE_SUGGESTION_BAR',
}

export const ListChunkSize = 20;
export const PriceDistributionSteps = 50;
export const PriceDistributionTrimPercentage = 5;
export const PageSize = 20;
export const DefaultRadius = 200000;
export const MobileSearchAlertModalName = 'mobileSearchAlert';

export const PreviewNumberOfListingsDebounceMs = 1000;

export const PreviewImageHeight = {
  [ScreenSize.XS]: 210,
  [ScreenSize.SM]: 210,
};

export const RequiredAnalyticsFilters = {
  endDate: '',
  startDate: '',
  priceMax: '',
  priceMin: '',
  categories: [],
  furniture: [],
  rooms: { bedroomCount: 0 },
  bills: [],
  suitableFor: [],
  registration: [],
  recentlyAdded: null,
  rules: [],
  gender: [],
};

export const KindsForSavedSearch = {
  [TypeValue.APARTMENT]: ['entire place'],
  [TypeValue.PRIVATE_ROOM]: ['private room'],
  [TypeValue.SHARED_ROOM]: ['shared room'],
  [TypeValue.STUDIO]: ['entire place'],
};

export const PageType = 'searchresults';
